export default __webpack_public_path__ + "static/media/WalletIcon.7808bdc8.svg";